import { collection, addDoc, query, where, getDocs, deleteDoc, doc, Timestamp, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';
import type { LeaseData, LeaseRecord } from '../types/lease';
import { analyzeTerms } from '../utils/leaseCalculator';

export async function saveLease(leaseData: LeaseData, userId: string): Promise<string> {
  if (!userId) throw new Error('User must be authenticated to save lease');

  const analysis = analyzeTerms(leaseData);
  
  const leaseRecord = {
    ...leaseData,
    userId,
    createdAt: serverTimestamp(),
    monthlyPayment: analysis.monthlyPayment,
    totalCost: analysis.totalCost,
    effectiveAPR: analysis.effectiveAPR,
    updatedAt: serverTimestamp()
  };

  try {
    const docRef = await addDoc(collection(db, 'leases'), leaseRecord);
    return docRef.id;
  } catch (error) {
    console.error('Error saving lease:', error);
    throw new Error('Failed to save lease analysis');
  }
}

export async function deleteLease(leaseId: string, userId: string): Promise<void> {
  if (!userId) throw new Error('User must be authenticated to delete lease');

  try {
    const leaseRef = doc(db, 'leases', leaseId);
    await deleteDoc(leaseRef);
  } catch (error) {
    console.error('Error deleting lease:', error);
    throw new Error('Failed to delete lease analysis');
  }
}

export async function getUserLeases(userId: string): Promise<LeaseRecord[]> {
  if (!userId) throw new Error('User ID is required');

  try {
    const leasesRef = collection(db, 'leases');
    const q = query(leasesRef, where('userId', '==', userId));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as LeaseRecord));
  } catch (error) {
    console.error('Error fetching leases:', error);
    throw new Error('Failed to fetch lease history');
  }
}